import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../css/subcategoryPage.css";
import axios from "axios";
import API_BASE_URL from "../config";

const SubcategoryPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");


  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/subcategory/${slug}`);
        setData(res.data); 
      } catch (err) {
        setError(err.response?.data?.message || err.message || "Something went wrong");
      }
    };
  
    fetchContent();
  }, [slug]);

  if (error) return <div className="error">{error}</div>;
  if (!data) return <div className="loading">Loading...</div>;

  return (
    <>
      {/* Top Banner */}
      <div
        className="hero-banner"
        style={{ backgroundImage: `url(${data.banner_image_url})` }}
      >
        <div className="hero-content">
          
          <h1>{data.title}</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="agriculture-section">
        <div className="agri-left">
          <h2>{data.subtitle}</h2>
          <p>{data.description}</p>
        </div>
      </div>
    </>
  );
};

export default SubcategoryPage;



